import React, { useMemo, useState } from "react";
import { unregisterAdherent } from "./../../../services/eventServices";
import Button from "./../../../components/Button/Button";
import { FaSave, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

const UnregisterAdherentModal = ({ isOpen, onClose, event, adherents, onChanged }) => {
  const [saving, setSaving] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const options = useMemo(() => Array.isArray(adherents) ? adherents : [], [adherents]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) {
      toast.error("Veuillez sélectionner un adhérent.");
      return;
    }
    try {
      setSaving(true);
      await unregisterAdherent(selectedId, event.id);
      toast.success("Adhérent désinscrit.");
      onChanged?.();
      onClose?.();
    } catch {
      toast.error("Erreur lors de la désinscription.");
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70]">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-[560px] bg-white dark:bg-slate-900 rounded-2xl shadow-2xl ring-1 ring-slate-200/70 dark:ring-slate-700/70 flex flex-col max-h-[80vh] overflow-hidden font-montserrat">
          <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 px-5 py-4 flex items-center justify-between rounded-t-2xl text-white">
            <h3 className="font-semibold">Désinscrire de : {event.titre}</h3>
            <Button text="Fermer" icon={FaTimes} onClick={onClose} className="!rounded-xl bg-white/10 hover:bg-white/20 text-white gap-2" />
          </div>

          <form onSubmit={handleSubmit} className="p-5 space-y-4 overflow-y-auto">
            <p className="text-sm opacity-80">
              ⚠️ Pensez à sauvegarder les résultats dans le palmarès avant la suppression.
            </p>

            <div>
              <label className="block text-xs mb-1 opacity-70">Adhérent inscrit</label>
              <select
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
                className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2"
                required
              >
                <option value="">{options.length ? "Choisir un adhérent" : "Aucun inscrit"}</option>
                {options.map((a) => (
                  <option key={a.id} value={a.id}>
                    {(a.nom || "").toUpperCase()} {a.prenom || ""}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-center gap-2 pt-2">
              <Button text={saving ? "Suppression..." : "Désinscrire"} icon={FaSave} type="submit" disabled={saving || !options.length} className="!rounded-xl gap-2" />
              <Button text="Annuler" icon={FaTimes} onClick={onClose} type="button" className="!rounded-xl !bg-slate-100 !text-slate-900 hover:!bg-slate-200 dark:!bg-slate-800 dark:!text-slate-100 dark:hover:!bg-slate-700 gap-2" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UnregisterAdherentModal;
